import { render, staticRenderFns } from "./feature.vue?vue&type=template&id=6097610a"
import script from "./feature.vue?vue&type=script&lang=js"
export * from "./feature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports